import { date } from "@/helpers/time";
import { formatDocument } from "../screenings/columns";
import { Contract } from "./types";

export const contractStatusLabels: Record<Contract["status"], string> = {
  preEnrolled: "Preingresado",
  enrolled: "Afianzado",
  retired: "Retirado",
};

export const formatCalendarDate = (value: string) =>
  date(value).format("D MMM YYYY");

export const formatMonth = (month: string) =>
  date(`${month}-01`).format("MMMM [de] YYYY");

export const coverageLabels = {
  months: { short: "C", label: "Canon" },
  integral: { short: "FI", label: "Fianza integral" },
  penalty: { short: "CP", label: "Cláusula penal" },
} as const;

export const activeCoverages = (contract: Contract) =>
  (Object.keys(coverageLabels) as (keyof typeof coverageLabels)[]).filter(
    (key) => contract.coverages[key]
  );

export const CONTRACT_TABLE_COLUMNS = [
  {
    key: "contractNumber",
    label: "Contrato",
    width: "1fr",
    minWidth: 160,
    exportTransform: (contract: Contract) => contract.contractNumber,
  },
  {
    key: "tenantDocumentNumber",
    label: "Documento",
    width: "1fr",
    minWidth: 150,
    exportTransform: formatDocument,
  },
  {
    key: "tenantName",
    label: "Arrendatario",
    width: "2fr",
    minWidth: 200,
    exportTransform: (contract: Contract) => contract.tenantName,
  },
  {
    key: "propertyAddress",
    label: "Inmueble",
    width: "2fr",
    minWidth: 200,
    exportTransform: (contract: Contract) => contract.propertyAddress,
  },
  {
    key: "monthlyRent",
    label: "Canon",
    width: "1fr",
    minWidth: 130,
    exportTransform: (contract: Contract) => contract.monthlyRent,
  },
  {
    key: "enrolledAt",
    label: "Ingreso a la fianza",
    width: "1fr",
    minWidth: 150,
    exportTransform: (contract: Contract) => contract.enrolledAt,
  },
  {
    key: "rentalsContractEndDate",
    label: "Fin del arrendamiento",
    width: "1fr",
    minWidth: 140,
    exportTransform: (contract: Contract) => contract.rentalsContractEndDate,
  },
  {
    key: "coverages",
    label: "Líneas",
    width: "1fr",
    minWidth: 110,
    exportTransform: (contract: Contract) =>
      activeCoverages(contract)
        .map((key) => coverageLabels[key].label)
        .join(", "),
  },
  {
    key: "status",
    label: "Estado",
    width: "1fr",
    minWidth: 120,
    exportTransform: (contract: Contract) =>
      contractStatusLabels[contract.status],
  },
  {
    key: "certificate",
    label: "Cert.",
    width: "1fr",
    minWidth: 80,
  },
] as const;
